<form #form="ngForm" autocomplete="off">
    <div class="app-grid" *ngIf="applicantMessageTemplate">
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'applicant-tracker.templateName' | appTranslate }}</mat-label>
            <input
                type="text"
                required
                #name="ngModel"
                name="name"
                [(ngModel)]="applicantMessageTemplate.name"
                matInput
            />
            <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'applicant-tracker.emailSubject' | appTranslate }}</mat-label>
            <input
                type="text"
                required
                #subject="ngModel"
                name="subject"
                [(ngModel)]="applicantMessageTemplate.subject"
                matInput
            />
            <mat-error *ngIf="subject.invalid">{{ subject.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.body' | appTranslate }}</mat-label>
            <ui-rich-text
                name="body"
                required
                height="175px"
                #body="ngModel"
                [(ngModel)]="applicantMessageTemplate.body"
                [stripNewlines]="true"
            >
            </ui-rich-text>
            <mat-error *ngIf="body.invalid">{{ body.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
